export default {
  name: "小付商城",
  adddress: "北京市朝阳区光华路SOHO2期C座 3-1",
  phone: "18001329761",
  email: "xiaofuqianbao@infohold.com.cn"
}



// WEBPACK FOOTER //
// ./src/config/aboutus.config.js